// External Libraries
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Actions
import { getCategoriesFunc } from "../../../store/custom-actions/categories-actions/GetCategoriesSlicer";
import { addCategoryFunc } from "../../../store/custom-actions/categories-actions/AddCategorySlicer";

// UI Components
import PageTitle from "../../layouts/PageTitle";
import FormField from "../../components/ui/FormField";
import CheckboxField from "../../components/ui/CheckboxField";
import SubmitButton from "../../components/ui/SubmitButton";
import NestedTreeSelector from "../../components/ui/NestedTreeSelector";
import MediaSelectorButton from "../../components/media/MediaSelectorButton";

function CreateCategory() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    register,
    reset,
    setValue,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const { loading, data: categoriesList } = useSelector(
    (state) => state.getCategoriesSlicer
  );
  const { loading: submitLoading } = useSelector(
    (state) => state.addCategorySlicer
  );

  const [parentId, setParentId] = useState(null);

  useEffect(() => {
    dispatch(getCategoriesFunc());
  }, [dispatch]);

  const onSubmit = async (data) => {
    const payload = {
      ...data,
      parent_id: parentId,
    };
    const result = await dispatch(addCategoryFunc({ data: payload }));
    if (addCategoryFunc.fulfilled.match(result)) {
      reset();
      navigate("/categories");
    }
  };

  return (
    <>
      <PageTitle
        motherMenu="Categories"
        activeMenu="New Category"
        motherMenuPath="/categories"
      />

      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h5 class="card-title">{t("Create Category")}</h5>
            </div>
            <div className="card-body">
              <form id="submit-form" onSubmit={handleSubmit(onSubmit)}>
                <FormField
                  label="Name"
                  name="name"
                  register={register}
                  required
                  errors={errors}
                />

                <div className="form-group mb-3">
                  <MediaSelectorButton
                    label="Category Image"
                    inputName="thumbnail_img"
                    register={register}
                    errors={errors}
                    onChange={(val) => setValue("thumbnail_img", val)}
                  />
                </div>

                <div className="form-group mb-3">
                  <label>{t("Main Category")}</label>
                  <NestedTreeSelector
                    treeData={categoriesList}
                    onSelect={setParentId}
                    loading={loading}
                  />
                </div>

                <CheckboxField
                  name="active"
                  label="Activity"
                  register={register}
                  errors={errors}
                  defaultChecked
                />

                <div className="text-end">
                  <SubmitButton isLoading={submitLoading} form="submit-form" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateCategory;
